<template>
	<div id="MyFx">
		<app-loader />
		<template v-if="!getInitLoader">
			<template v-if="$route.path !== '/Login'">
				<div>
					<learning-modal
						v-if="
							showLearningCloseInfo ||
							showLearningCloseVideo ||
							showLearningCloseTest
						"
						:modalType="infoSection"
						:videoSection="videoSection"
						:isTest="testSection"
						:leavePage="getIsLeaving"
						:changePath="getPath"
						:isTimeOver="getTimeIsOverModal"
					/>
					<app-all-modals />
					<app-border-top />
					<app-header />
					<div class="wrapper">
						<app-content />
						<contact-button
							v-if="$route.meta.title !== 'eLearning'"
						/>
					</div>
				</div>
			</template>
			<template v-else>
				<app-login />
			</template>
			<app-footer />
		</template>
	</div>
</template>

<script>
import AppContent from '@/components/AppContent';
import AppBorderTop from '@/components/AppBorderTop';
import AppFooter from '@/components/AppFooter';
// import AppCookies from '@/components/AppCookies';
import AppLogin from '@/views/login/LoginView';
import ContactButton from '@/components/ContactButton';
import AppLoader from '@/components/AppLoader';
import AppHeader from '@/components/AppHeader';
import LearningModal from '@/views/Learning/partial/LearningModal';
import AppAllModals from '@/components/AppAllModals';
import { mapGetters } from 'vuex';

export default {
	components: {
		AppContent,
		AppBorderTop,
		AppFooter,
		// AppCookies,
		AppLogin,
		ContactButton,
		AppLoader,
		AppHeader,
		LearningModal,
		AppAllModals,
	},
	methods: {
		resize() {
			this.$store.dispatch('windowResize');
		},
	},
	computed: {
		...mapGetters([
			'getIsLeaving',
			'getPath',
			'getLearningModal',
			'getTimeIsOverModal',
			'getCurrentUser',
			'getLoaderShow',
			'getInitLoader',
		]),
		mobileMenu() {
			return this.$store.getters.getShowMobileMenu;
		},
		showLearningCloseInfo() {
			return (
				this.getLearningModal &&
				!this.$cookies.get('learningInformation') &&
				this.$route.name === 'eLearning'
			);
		},
		showLearningCloseVideo() {
			return (
				this.getLearningModal && this.$route.name === 'eLearningVideos'
			);
		},
		showLearningCloseTest() {
			return (
				this.getLearningModal && this.$route.name === 'eLearningTest'
			);
		},
		infoSection() {
			return this.$route.name === 'eLearning';
		},
		videoSection() {
			return this.$route.name === 'eLearningVideos';
		},
		testSection() {
			return this.$route.name === 'eLearningTest';
		},
	},
	async beforeMount() {
		await this.$store.dispatch('fetchSettings');
		// await this.$store.dispatch('fetchCurrentUser');
		this.resize();
		var t = this;
		window.addEventListener('resize', function () {
			t.resize();
		});

		// if (!this.getCurrentUser) return;
		// this.$store.dispatch('autoLogIn');
	},
};
</script>
